import { get, find } from "lodash"
import { createSelector } from "reselect"
import { getMostUsedOrDefaultModelId } from "helpers/models"
import { createUnmodeledDatesSelector } from "selectors/dates"
import { getPortfolioDates } from "modules/research-topic-root/selectors"

const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}

export const getModeledDates = state => get(state, "global.data.topicModeledDates.data.model.availability.dates")
export const getModels = state => get(state, "global.data.modelsAvailability.data.models", EMPTY_ARRAY)
export const getPortfolios = state => get(state, "global.data.portfolios.data", EMPTY_ARRAY)
export const getSelectedModel = state => get(state, "modules.researchTopicCreate.selectedModel")
export const getInstrument = state => get(state, "modules.researchTopicCreate.instrument", EMPTY_OBJECT)
export const getSelectedDate = state => get(state, "modules.researchTopicCreate.selectedDate")
export const getRawInstrumentAvailability = state => get(state, "global.data.researchTopicInstrument.data")

export const getModel = createSelector(
  [getSelectedModel, getModels, getPortfolios],
  (selectedModel, models, portfolios) => {
    if (selectedModel) { return selectedModel }
    return getMostUsedOrDefaultModelId(portfolios, models)
  },
)

export const getModelAvailability = createSelector(
  [getModel, getModels],
  (selectedModel, models) => {
    const modelData = find(models, { id: selectedModel })
    return get(modelData, "availability")
  },
)

export const getInstrumentAvailability = createSelector(
  [getInstrument, getRawInstrumentAvailability, getModelAvailability, getPortfolioDates],
  (instrument, rawInstrumentAvailability, modelAvailability, portfolioDates) => {
    let earliestDate
    let latestDate
    if (instrument.type === "portfolio") {
      const lastUploadedDate = get(portfolioDates, "latest")
      const latestPortfolioDate = lastUploadedDate > modelAvailability.currentDate ? modelAvailability.currentDate : lastUploadedDate
      const { availableFrom, rolloverPositionSetToCurrentDate } = get(rawInstrumentAvailability, "portfolio") || {}
      earliestDate = availableFrom
      latestDate = rolloverPositionSetToCurrentDate ? modelAvailability.currentDate : latestPortfolioDate
    } else {
      earliestDate = get(rawInstrumentAvailability, "model.security.availability.from")
      latestDate = get(rawInstrumentAvailability, "model.security.availability.to")
    }

    return {
      earliestDate,
      latestDate,
    }
  },
)

const getUnmodeledDates = createUnmodeledDatesSelector(getModeledDates)

export const getAvailability = createSelector(
  [getModelAvailability, getInstrumentAvailability, getUnmodeledDates],
  (modelAvailability, instrumentAvailability, unmodeledDates) => {
    const { earliestDate, latestDate } = instrumentAvailability || {}
    const { securitiesStartDate: earliestModeledDate, currentDate: latestModeledDate } = modelAvailability || {}

    return {
      earliestDate: earliestModeledDate > earliestDate ? earliestModeledDate : earliestDate,
      latestDate: latestModeledDate < latestDate ? latestModeledDate : latestDate,
      unmodeledDates,
    }
  },
)
